module.exports = __webpack_public_path__ + "img/spicy_fifty_1.6e8a574d.jpg";